"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagHasChildrenError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when try to delete a tag which has child tags
 */
class TagHasChildrenError extends client_library_1.ExtendableError {
    constructor() {
        super(`Tag has child tags and cannot be deleted`);
    }
}
exports.TagHasChildrenError = TagHasChildrenError;
//# sourceMappingURL=TagHasChildrenError.js.map